// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import FleetSelector from './pages/FleetSelector';
import DriverListPage from './pages/DriverListPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/fleets" element={<FleetSelector />} />
        <Route path="/fleets/:fleetUid/drivers" element={<DriverListPage />} />
        {/* You might add a route for a general "drivers" page, 
            which could redirect to the first fleet's drivers if needed */}
        <Route path="/drivers/:fleetUid/:driverUid" element={<div> {/* Placeholder for Driver Details Page */}
          <h2>Driver Details</h2>
          <p>Driver UID: :driverUid</p>
          <p>Fleet UID: :fleetUid</p>
          {/* Implement your DriverDetails component here */}
        </div>} />
      </Routes>
    </Router>
  );
}

export default App;
